import React from "react";
import Index from "./pages/Index";
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import {CacheProvider} from "@emotion/react";
import AboutUs from "./pages/AboutUs";
import Blog from "./pages/Blog";
import {BrowserRouter as Router, Routes, Route, Outlet, Navigate} from "react-router-dom";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import Blogs from "./pages/Blogs";
import {useSettingState} from "./context/SettingContext";
import {useAuthState} from "./pages/admin/context/AuthContext";
import Main from "./pages/admin/pages/Main";
import UserList from "./pages/admin/pages/users/UserList";
import NewUser from "./pages/admin/pages/users/NewUser";
import User from "./pages/admin/pages/users/User";
import News from "./pages/admin/pages/news/News";
import NewsList from "./pages/admin/pages/news/NewsList";
import Service from "./pages/admin/pages/services/Service";
import ServiceList from "./pages/admin/pages/services/ServiceList";
import Customer from "./pages/admin/pages/Customer";
import CoWork from "./pages/admin/pages/CoWork";
import Slider from "./pages/admin/pages/Slider";
import Settings from "./pages/admin/pages/Settings";
import Contact from "./pages/admin/pages/Contact";
import Login from "./pages/admin/pages/user/auth/Login";
import {useEffect} from "react";
import Benefit from "./pages/admin/pages/Benefit";
import CategoryList from "./pages/admin/pages/news/CategoryList";
import Category from "./pages/admin/pages/news/Category";

function App() {

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [rtlPlugin],
    });
    const auth = useAuthState();

    useEffect(() => {
        if (localStorage.getItem("token") && !auth.isAuthenticated) {
            auth.checkUser();
        }
    }, [auth.isAuthenticated]);
    return (
        <CacheProvider value={cacheRtl}>
            <Router>
                <Routes>
                    <Route element={
                        <PrivateRoute>
                            <Main/>
                        </PrivateRoute>} path={'/admin'}>

                        <Route element={<PrivateRoute>
                            <UserList/>
                        </PrivateRoute>} path={"users"}/>

                        <Route element={<PrivateRoute>
                            <NewUser/>
                        </PrivateRoute>} path={"new-user"}/>


                        <Route path={'user/:id'} element={
                            <PrivateRoute>
                                <User/>
                            </PrivateRoute>} exact/>


                        <Route element={<PrivateRoute>
                            <News/>
                        </PrivateRoute>} path={"new-news"}/>

                        <Route element={<PrivateRoute>
                            <News/>
                        </PrivateRoute>} path={"news/:id"}/>

                        <Route element={<PrivateRoute>
                            <NewsList/>
                        </PrivateRoute>} path={"news"}/>




                        <Route element={<PrivateRoute>
                            <Category/>
                        </PrivateRoute>} path={"new-category"}/>

                        <Route element={<PrivateRoute>
                            <Category/>
                        </PrivateRoute>} path={"category/:id"}/>

                        <Route element={<PrivateRoute>
                            <CategoryList/>
                        </PrivateRoute>} path={"category"}/>




                        <Route element={<PrivateRoute>
                            <Service/>
                        </PrivateRoute>} path={"service/:id"}/>
                        <Route element={<PrivateRoute>
                            <Service/>
                        </PrivateRoute>} path={"new-service"}/>

                        <Route element={<PrivateRoute>
                            <ServiceList/>
                        </PrivateRoute>} path={"service"}/>

                        <Route element={<PrivateRoute>
                            <Customer/>
                        </PrivateRoute>} path={"customer"}/>

                        <Route element={<PrivateRoute>
                            <Customer/>
                        </PrivateRoute>} path={"customer/:id"}/>

                        <Route element={<PrivateRoute>
                            <Benefit/>
                        </PrivateRoute>} path={"benefit"}/>

                        <Route element={<PrivateRoute>
                            <Benefit/>
                        </PrivateRoute>} path={"benefit/:id"}/>

                        <Route element={<PrivateRoute>
                            <Contact/>
                        </PrivateRoute>} path={"contact"}/>

                        <Route element={<PrivateRoute>
                            <Contact/>
                        </PrivateRoute>} path={"contact/:id"}/>

                        <Route element={<PrivateRoute>
                            <CoWork/>
                        </PrivateRoute>} path={"co-work"}/>

                        <Route element={<PrivateRoute>
                            <CoWork/>
                        </PrivateRoute>} path={"co-work/:id"}/>

                        <Route element={<PrivateRoute>
                            <Slider/>
                        </PrivateRoute>} path={"images"}/>

                        <Route element={<PrivateRoute>
                            <Settings/>
                        </PrivateRoute>} path={"setting"}/>

                    </Route>


                    <Route element={
                        <PublicRoute>
                            <Login/>
                        </PublicRoute>
                    } path={'/admin/login'} exact/>



                    <Route path={'/'} element={<Page/>}>
                        {/*<Route index element={<Blog/>}/>*/}
                        <Route path={"/about-us"} element={<AboutUs/>} exact/>
                        <Route path={"blog/:id"} element={<Blog/>} exact/>
                        <Route path={"blogs"} element={<Blogs/>} exact/>
                        <Route path={"/"} element={<Index/>} exact/>

                    </Route>

                </Routes>

            </Router>
        </CacheProvider>
    );
}

export default App;


const Page = (props) => {
    const setting = useSettingState();

    return <div>
        <Menu/>
        <Outlet/>
        <Footer places={setting.state.footer.places} mail={setting.state.footer.mail} main={setting.state.footer.index}/>
    </div>
}


const PrivateRoute = ({children}) => {
    const auth = useAuthState();
    return auth.isAuthenticated ? children : <Navigate to="/admin/login"/>;
}

const PublicRoute = ({children}) => {
    const auth = useAuthState();
    return auth.isAuthenticated ? <Navigate to={`/admin`}/> : children;
}